import { useSingleUserController } from "../controllers/useSingleUserController";
import { useGetRolePermissionsQuery } from "../redux/services/staffApi";


export const usePermission = () => {
  const { userDetails, isLoading: isLoadingUser } = useSingleUserController();

  const getRoleId = (roleData: any): string | null => {
    if (typeof roleData === "object" && roleData?.id) {
      return roleData.id;
    }
    return null;
  };

  const roleId = getRoleId(userDetails?.role);

  const { data: rolePermissions, isLoading: isLoadingRolePermissions } = useGetRolePermissionsQuery(roleId || "", {
    skip: !roleId,
  });

  // True only while we genuinely don't know the permission set yet (first
  // load) — callers that gate access on this (e.g. PermissionGate) should
  // wait rather than treat "not loaded yet" as "no permissions".
  const isLoading = isLoadingUser || (!!roleId && isLoadingRolePermissions);

  const permissionNames =
    rolePermissions?.permissions?.map((perm: any) => perm.name) ?? [];

  const permissionDescriptions =
    rolePermissions?.permissions?.map((permission: any) => permission.description) ?? [];

  const hasPermission = (permission: string) => {
    return (
      permissionNames.includes(permission) ||
      permissionDescriptions.includes(permission)
    );
  };

  return {
    hasPermission,
    permissionNames,
    permissionDescriptions,
    rolePermissions,
    isLoading,
  };
};